/*************************************************************************
* ADOBE SYSTEMS INCORPORATED
*  Copyright 2017 Adobe Systems Incorporated
*  All Rights Reserved.
*
* NOTICE:  Adobe permits you to use, modify, and distribute this file in
* accordance with the terms of the Adobe license agreement accompanying it.
* If you have received this file from a source other than Adobe, then your
* use, modification, or distribution of it requires the prior written
* permission of Adobe.
**************************************************************************/

/*jslint node: true, nomen: true, maxlen: 120 */
/*eslint no-shadow: 0 */
/*global */
'use strict';

var AdobeDC = require('./adobe-dc');

/**
 * Extend http with automatic JSON handling,
 * e.g. http = handleJsonHttp(AdobeDC.http);
 */
function handleJsonHttp(http) {
    var newHttp = Object.create(http);
    newHttp.call = function (method, url, options, content) {
        var self = this,
            type = options && self.getHeader(options.headers, "Content-Type"),
            promise1,
            promise2;
        // Convert to a string if needed.
        if (typeof content !== 'string' && type && /json;|json$/.test(type)) {
            content = JSON.stringify(content);
        }
        function handleResult(result, type) {
            // Convert from a string if needed.
            if (typeof result.content === 'string' && type && /json;|json$/.test(type) && result.status !== 204) {
                result.content = JSON.parse(result.content);
            }
        }
        // Forward special additions to the promise if present.
        // Use a new Promise to allow the failure error to be adjusted as well as the success result.
        promise1 = http.call(method, url, options, content);
        promise2 = new Promise(function (resolve, reject) {
            promise1.then(function pass(result) {
                handleResult(result, self.getHeader(result.headers, "Content-Type"));
                resolve(result);
            }, function fail(err) {
                if (err instanceof AdobeDC.AdobeError && err.details) {
                    // Create a new error to re-encapsulate the adjusted details.
                    // Otherwise the err.details.content may not be adjusted in the Promise handling.
                    handleResult(err.details, self.getHeader(err.details.headers, "Content-Type"));
                    err = new AdobeDC.AdobeError(err.message, err.code, err.details);
                }
                reject(err);
            });
        });
        promise2.request = promise1.request;
        return promise2;
    };
    return newHttp;
}

module.exports = {
    handleJsonHttp: handleJsonHttp
};
